import React from "react"
import Layout from "../components/layout"
import BlogPosts from '../components/blog-posts'
import WuformButton from '../components/wuform-button'
import SuccessBtnDumpsters from "../components/success-btn-dumpsters"
import LayoutDumpster from "../components/layout-dumpster"
import HowvideoDumpsters from "../components/howvideo-dumpsters"

const PROGUIDEPAGEDUMPSTERS = ({ pageContext }) => 
{ 
    const code = pageContext.code;
    const posts = pageContext.posts;
    const env = pageContext.env;      

    const seo = 
    {
        url: 'pro/guide',
        env: env,
        code: code,
        page: 'guides'
    }

    return (
        <LayoutDumpster seo={seo} env={env} hidden={true} callToAction={true}>
            <div className="blog">
                <div className="container mb-5">
                    <div className="row">
                        <div className="col-lg-8">
                            <BlogPosts posts={posts}/>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar no-margin">
                                <div className="block">
                                    <WuformButton env={env} />
                                </div> 

                                <div className="block">
                                    <HowvideoDumpsters /> 
                                </div>
                                
                                <div className="block">                                    
                                    <SuccessBtnDumpsters />
                                </div>                                        
                            </div>                            
                        </div>
                    </div>
                </div>           
            </div> 
        </LayoutDumpster>
    )
};

export default PROGUIDEPAGEDUMPSTERS;